import React from 'react';

import ContentBlocksWithRedux from '../../organisms/content-blocks/contentBlocks.withRedux';
import TemplateDefault from '../../templates/default/default';
import HighlightStage from '../../organisms/highlight-stage/highlightStage';
import BookingFilter from '../../organisms/booking-filter/bookingFilter';
import StyledGuidedTours from './guidedTours.style';

const GuidedTours = () => {
  return (
    <TemplateDefault invertedHeaderLogo>
      <StyledGuidedTours>
        <HighlightStage />
        <ContentBlocksWithRedux noShareLinks />
      </StyledGuidedTours>
      <BookingFilter />
    </TemplateDefault>
  );
};

export default GuidedTours;
